module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "corporateBox"
  }, [_vm._l((_vm.corporates), function(corporate) {
    return _c('div', {
      staticClass: "c-row",
      on: {
        "click": function($event) {
          return _vm.select(corporate)
        }
      }
    }, [_vm._v("\n    " + _vm._s(corporate.name) + "\n    " + _vm._s(corporate.prefecture_name) + "\n    " + _vm._s(corporate.city_name) + "\n    " + _vm._s(corporate.street_address) + "\n  ")])
  }), _vm._v(" "), (_vm.show) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.show = false
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("確認")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_vm._v("\n      " + _vm._s(_vm.selectCorporate.name)), _c('br'), _vm._v("\n      " + _vm._s(_vm.selectCorporate.prefecture_name) + "\n      " + _vm._s(_vm.selectCorporate.city_name) + "\n      " + _vm._s(_vm.selectCorporate.street_address)), _c('br'), _vm._v("\n      を反映しますか？\n    ")]), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary modal-default-button",
    on: {
      "click": _vm.activate
    }
  }, [_vm._v("反映")]), _vm._v(" "), _c('button', {
    staticClass: "btn modal-default-button",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("Close")])])], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa01d56e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/CorporateRow.vue
// module id = 493
// module chunks = 1